import React, { useEffect, useRef } from 'react';
import { arrayOf, oneOfType, element, func, shape, string } from 'prop-types';

import { setSnackbar } from '../context/snackbar';
import MapMobile from './map.mobile';
import { useMapView } from './hooks/use-map-view';
import useAutoHeight from '../../hooks/use-auto-height';
import Carousel from './carousel/carousel';
import { useSelectedItem } from './hooks/use-selected-item';
import { PolygonProvider } from './context/polygon-context';

const MapMobileContainer = ({ className, itemComponent, results }) => {
  const mapRef = useRef(null);
  const { isLoading, showZrp, fitMarkersInMap, map_configuration, fixedCoords, updateResults, setError } = useMapView({
    results,
    mapRef,
  });
  const { selectedMarker, selectedSlide, setSelectedMarker, setSelectedSlide } = useSelectedItem();
  const { height, containerRef } = useAutoHeight(500);

  const handlePolygonError = () => {
    setError(true);
  };

  useEffect(() => {
    if (showZrp && map_configuration?.zrp) {
      setSnackbar({
        message: map_configuration.zrp.zrp_message || '',
        className: 'ui-search-map-snackbar',
      });
    }
  }, [showZrp, map_configuration?.zrp]);

  return (
    <PolygonProvider>
      <div className={className} style={{ height }} ref={containerRef}>
        <MapMobile
          ref={mapRef}
          fitMarkersInMap={fitMarkersInMap}
          fixedCoords={fixedCoords}
          isLoadingResults={isLoading}
          markers={results}
          updateResults={updateResults}
          selectedMarker={selectedMarker}
          setSelectedMarker={setSelectedMarker}
          onPolygonError={handlePolygonError}
        />
        <Carousel
          ItemComponent={itemComponent}
          results={results}
          onSlideChange={setSelectedSlide}
          selectedItemIndex={selectedSlide}
        />
      </div>
    </PolygonProvider>
  );
};

MapMobileContainer.propTypes = {
  className: string,
  itemComponent: oneOfType([element, func]).isRequired,
  results: arrayOf(shape()),
};

MapMobileContainer.defaultProps = {
  className: null,
  results: [],
};

export default MapMobileContainer;
